// extracted by mini-css-extract-plugin
export default {"addressAction":"k8-z","loading":"l8-z"};